import { Avatar } from '@mui/material';
import { Add } from '@mui/icons-material';
import Link from 'next/link';
import { MobileTooltip } from 'components/MobileTooltip';

const AVATAR_SIZE = 30;

interface Props {
  title: string;
  path: string;
  newPostCard?: boolean;
}

export const AddCreditAvatar = ({ title, path, newPostCard = false }: Props) => (
  <Link href={`${path}?add=1`}>
    <MobileTooltip
      title={title}
      key="add"
      arrow
    >
      <Avatar
        className={`mr-1 cursor-pointer bg-black ${newPostCard ? 'border-0' : 'border-2'} text-white hover:border-orange hover:text-orange`}
        sx={{ width: AVATAR_SIZE, height: AVATAR_SIZE, backgroundColor: 'black' }}
        key="plus"
        variant="circular"
        alt="plus"
      >
        <Add />
      </Avatar>
    </MobileTooltip>
  </Link>
);
